<template>
    <!-- <Breadcrumbs main="SALES" mains="Point Of Sales" title="POS" /> -->
    <div class="container-fluid default-dashboard pt-2">
        <div class="row">
            <Card1 colClass="col-sm-5 box-col-6" cardClass="card widget-1">
                <FormPatient @on-processed="fetchRegistration()" />
            </Card1>
            <Card1 colClass="col-md-7 box-col-12" cardClass="card" cardhaderClass="card-no-border pb-0" header="true"
                title="Registasi History" cardbodyClass="transaction-history pt-0">
                <div class="table-responsive theme-scrollbar">
                    <DataTableRange :headers="headers" :items="orderHistory" :loading="loading"
                        :total="total" :params="params" @update:params="updateParams">
                        <template #item.patient_photo="{ item }">
                            <div class="d-flex align-items-center">
                                <div class="avatar">
                                    <img v-if="item.patient_photo" :src="item.patient_photo" class="rounded-circle"
                                        width="40" height="40" :alt="item.name">
                                    <div v-else
                                        class="rounded-circle bg-light d-flex align-items-center justify-content-center"
                                        style="width: 40px; height: 40px;">
                                        <i class="fa fa-user text-secondary"></i>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template #item.source="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                            {{ item.source }} {{ item.sales_name }}
                        </template>
                        <template #item.transaction_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                            <a href="javascript:void(0)" class="text-decoration-none"
                                @click="showRegistrationCard(item)">
                                <i class="fa fa-upload"></i>
                                {{ formatDateTime(item.registration_date) }}
                            </a>
                        </template>
                        <template #item.process="{ item }">
                            <a href="javascript:void(0)" class="text-primary me-2 text-decoration-none" title="Process"
                                @click="showRegistrationCardUpdate(item)">
                                <i class="fa fa-cog"></i>
                            </a>
                            &nbsp;
                            <a href="javascript:void(0)" class="text-danger text-decoration-none" title="Delete"
                                @click="deleteRegis(item)">
                                <i class="fa fa-trash"></i>
                            </a>
                        </template>
                    </DataTableRange>
                </div>
            </Card1>
        </div>
    </div>
    <RegistrationCard ref="registrationCard" :title="cardtitle" :data="selectPatient" v-if="cardPatient"
        @on-closed="cardPatient = !cardPatient" />
    <RegistrationCardUpdate ref="registrationCardUpdate" :title="cardtitle" :data="selectPatientUpdate"
        @on-closed="cardPatientUpdate = !cardPatientUpdate" />
</template>

<script lang="ts" setup>
import { onMounted, ref, reactive, defineAsyncComponent } from "vue"
import DataTableRange from '@/components/table/DatatableDateRange.vue'
import * as clinic from "@/api/services/ClinicRequest";
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))
const FormPatient = defineAsyncComponent(() => import("./FormPatient.vue"))
const RegistrationCard = defineAsyncComponent(() => import("./RegistrationCard.vue"))
const RegistrationCardUpdate = defineAsyncComponent(() => import("./RegistrationCardUpdate.vue"))
import { useSessionStore } from '@/store/session';
import { toast } from 'vue3-toastify'
const session = useSessionStore()
const role = ref(session.getUser().role)
const headers = [
    { text: '#', value: 'patient_photo' },
    // { text: 'REG No', value: 'code' },
    { text: 'Registration Date', value: 'transaction_date' },
    { text: 'Pasien', value: 'name' },
    { text: 'Keluhan', value: 'keluhan' },
    { text: 'Info', value: 'source' },
    { text: 'Status', value: 'status' },
    { text: 'Process', value: 'process' } // new column for button
]
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: '',
    clinic: session.getUser().clinic
})

const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchRegistration()
}
const orderHistory = ref<any>([])
const total = ref(0)

const loading = ref(false)
async function fetchRegistration() {
    loading.value = true
    await clinic.postRequest("/registration/list", params).then((res) => {
        if (res.status == 200 && res.data) {
            orderHistory.value = res.data
            total.value = res.total
        } else {
            orderHistory.value = []
            total.value = 0
        }
    })
    loading.value = false
}

onMounted(() => {
    // fetchRegistration()
})
function formatDateTime(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
}
const cardPatient = ref(false)
const cardPatientUpdate = ref(false)
const selectPatient = ref({})
const selectPatientUpdate = ref({})
const cardtitle = ref('Registration Details')

const registrationCard = ref()
const showRegistrationCard = (item: any) => {
    selectPatient.value = item
    cardPatient.value = true
    registrationCard.value.openModal()
}

const registrationCardUpdate = ref()
const showRegistrationCardUpdate = (item: any) => {
    selectPatientUpdate.value = item
    cardPatientUpdate.value = true
    registrationCardUpdate.value.openModal()

}

const deleteRegis = async (item: any) => {
    if (!confirm('Are you sure you want to delete this registration?')) return

    loading.value = true; // Indicate loading state
    try {
        // Simulate API call
        await clinic.postRequest("/registration/delete", { ID: item.ID }).then((resp) => {
            if (resp.status === 200) {
                toast.success('deleted successfully');
                fetchRegistration(); // Re-fetch to update the table view
            } else {
                toast.error('Failed to delete registration');
            }
        })

    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to delete registration');
    } finally {
        loading.value = false; // End loading state
    }
}

</script>